import { useI18n } from '@app-velocity/i18n';

import { PrimaryPage } from '../../../layouts';
import { NewReviewForm } from './components/NewReviewForm';

export const SelectPageForReview = () => {
  const { t } = useI18n();

  return (
    <PrimaryPage
      back=".."
      backLabel={t('shared:home')}
      title={t('appraisals:select_design_for_review')}
    >
      <NewReviewForm />
    </PrimaryPage>
  );
};
